import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAttributes, IAugmentedJQuery, IModule, IRootScopeService, ISCEService, ITimeoutService} from "angular";
import {Autentisering} from "felles/tjenester/Autentisering";
import {CriiptoOIDCRessurs} from "felles/tjenester/ressurser/CriiptoOIDCRessurs";
import {Debugger} from "debug";
import {CriiptoAutentiseringBasis} from "felles/komponenter/autentisering/criiptoautentiseringBasis";
import {gettextCatalog} from "angular-gettext";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";

const debug: Debugger = require('debug')('CriiptoAutentiseringKontroller');
const css = require('./criiptoautentisering.scss');

export class CriiptoAutentiseringKontroller extends CriiptoAutentiseringBasis {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmCriiptoAutentisering', {
                bindings: {
                    modus: '<?',
                    eidmetoder: '<?',
                    tokenvarighet: '<?',
                    criiptoCallbackparams: '<?',
                    vedValgt: '&?',
                    vedCriiptoCallback: '&?',
                    vedAutentisert: '&?',
                    vedBrukerIkkeFunnet: '&?',
                    vedAvbrutt: '&?',
                    vedFeil: '&?'
                },
                controller: CriiptoAutentiseringKontroller.forInjisering(),
                template: require('./criiptoautentisering.html')
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$element,
            regNavn.ng.$attrs,
            regNavn.ng.$rootScope,
            regNavn.ng.$timeout,
            regNavn.ng.$sce,
            Autentisering.regNavn,
            CriiptoOIDCRessurs.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            CriiptoAutentiseringKontroller
        ]
    }

    constructor(private $element: IAugmentedJQuery,
                $attrs: IAttributes,
                $rootScope: IRootScopeService,
                $timeout: ITimeoutService,
                $sce: ISCEService,
                autentisering: Autentisering,
                criiptoOIDCRessurs: CriiptoOIDCRessurs,
                meldingTilBruker: MeldingTilBruker,
                gettextCatalog: gettextCatalog) {
        super($attrs, $rootScope, $timeout, $sce, autentisering, criiptoOIDCRessurs, meldingTilBruker, gettextCatalog);
    }

}
